enum EGlobalIcons {
  close = '//images2.r.pl/r-pl/nuxt/ui/close-circle.svg',
  xLight = '//images2.r.pl/r-pl/nuxt/filtry/x-light.svg',
}
export default EGlobalIcons;
